import background from 'assets/Resc_Office.png';
import { CustomInput } from 'components/UI/CustomInput';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updatePasswordWithCode } from 'services/account/account.service';
import { getLogo } from 'utils/images/image.utils';
import { validatePassword } from 'features/Auth/utils/password.utils';
import { useDispatch } from 'react-redux';
import { setUserEmail } from 'store/slices/User/userSlice';

export default function ResetPassword({
  setShowSmallMenu,
  mobile = false,
  setPrivacyAgreed,
  setCookiesAgreed,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [errorColor, setErrorColor] = useState('red');
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const redirectTimer = React.useRef(null);
  const [success, setSuccess] = useState(false);
  const code = searchParams.get('code');

  useEffect(() => {
    return () => {
      if (redirectTimer.current) clearTimeout(redirectTimer.current);
    };
  }, []);

  useEffect(() => {
    setShowSmallMenu(false);
    if (!code) {
      navigate('/');
    }
  }, []);

  const handleSubmit = async () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      setErrorColor('red');
      return;
    }

    const result = validatePassword(newPassword);
    if (!result.isValid) {
      setError(result.message);
      setErrorColor('red');
      return;
    }

    setError(null);

    try {
      await updatePasswordWithCode(newPassword, code);

      // success message then auto-redirect
      setErrorColor('green');
      setError('Password changed successfully');
      setSuccess(true);

      redirectTimer.current = setTimeout(() => {
        goToRedirect();
      }, 1500);
    } catch (e) {
      setSuccess(false);
      setErrorColor('red');
      setError('Error changing password: ' + (e?.response?.data?.message || e.message));
    }
  };

  useEffect(() => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!validatePassword(newPassword).isValid) {
      setError(validatePassword(newPassword).message);
      return;
    }

    setError(null);
  }, [newPassword, confirmPassword]);

  const goToRedirect = async () => {
    if (Cookies.get('rememberMe') === 'false') dispatch(setUserEmail(''));

    // setShowSmallMenu(true);
    setCookiesAgreed(true);
    setPrivacyAgreed(true);
    navigate('/passwordRedirect');
  };

  return (
    <div>
      <Container
        fluid
        className="vh-100 overflow-y-auto"
        style={{ margin: 0, padding: 0, position: 'fixed', inset: 0 }}
      >
        <div className="flex-box row g-0 h-100 position-relative">
          <div
            className="col-12 col-md-6 d-none d-md-block flex-grow-1 p-0"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: '60% 100%',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="row g-0 h-100 align-items-end text-center">
              <div
                className="mb-5"
                style={{
                  WebkitTextStroke: '0.3px black',
                  color: 'var(--color-font)',
                }}
              >
                <div style={{ fontSize: 20 }}>Overwatch Fusion+ </div>
                <div style={{ fontSize: 36 }}>Powered by RescAlert Inc.</div>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-around p-0"
            style={{ background: 'var(--color-background)', color: 'var(--color-font)' }}
          >
            {/* Logo */}
            <img
              className="p-3"
              src={getLogo(true)}
              style={{ width: '80%', maxWidth: 500, marginTop: '5%' }}
              alt="Logo"
            />

            {/* Form */}
            <div className="w-100 p-3" style={{ maxWidth: 380 }}>
              <div className="mb-5">
                <h1 className="mb-2">Reset Password</h1>
                <div style={{ color: '#A0AEC0' }}>Please enter your new password</div>
              </div>
              <div className="mb-3">
                <div className="py-1 mx-2">New Password</div>

                <CustomInput
                  value={newPassword}
                  callback={setNewPassword}
                  type="password"
                  placeholder="Your new password"
                />
              </div>
              <div className="mb-3">
                <div className="py-1 mx-2">Confirm New Password</div>

                <CustomInput
                  value={confirmPassword}
                  callback={setConfirmPassword}
                  type="password"
                  placeholder="Confirm new password"
                />
              </div>

              {error && (
                <div className="mt-2" style={{ color: errorColor }}>
                  {error}
                </div>
              )}

              <Button
                variant="primary"
                className="w-100 rounded-4 mt-5 mb-3 py-3"
                onClick={() => handleSubmit()}
                disabled={
                  !newPassword ||
                  !confirmPassword ||
                  newPassword !== confirmPassword ||
                  !validatePassword(newPassword).isValid
                }
              >
                Reset Password
              </Button>

              <div className="text-center mt-3">
                <span style={{ color: '#A0AEC0' }}>Already have an account? </span>
                <a
                  href={'/'}
                  style={{
                    color: 'var(--color-font)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Sign in
                </a>
              </div>
            </div>
            {/* <div className="text-center mt-4">
              <div className="mb-2 fs-5">Sign in with</div>

              <div className="d-flex w-100 flex-nowrap gap-3">
                <Button
                  variant="light"
                  className="flex-fill d-inline-flex align-items-center gap-2 rounded-4 shadow-sm px-5 py-3 text-dark"
                  onClick={() => navigate("/")}
                  aria-label="Sign in with Microsoft"
                >
                  <img src={msLogo} alt="Microsoft" width={28} height={28} />
                  <span className="fw-medium text-nowrap">Microsoft</span>
                </Button>
              </div>
            </div> */}
            <footer className="w-100 py-3 text-center">
              <div className="mb-2">
                <span style={{ color: '#A0AEC0' }}>Don’t have an account? </span>
                <a
                  href="/contact"
                  style={{
                    color: 'var(--color-font)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Contact Us
                </a>
              </div>
              <small
                style={{
                  color: 'var(--color-font)',
                  textShadow: '0 1px 2px rgba(0,0,0,.4)',
                }}
              >
                © 2023 – {new Date().getFullYear()}, Powered by RescAlert Inc.
              </small>
              <div className="d-flex justify-content-center flex-wrap gap-4">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Marketplace
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Blog
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  License
                </button>
              </div>
            </footer>
          </div>
        </div>
      </Container>
    </div>
  );
}
